import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface PartnerState extends BasePageState {}
interface PartnerModel {}

import { injectPhpDebug } from '../../../../mol_function';

import './index.scss';
import setupImage from './images/setupImage.jpeg';
import exampleShop from './images/exampleShop_new.jpg';
import dropshipping from './images/dropshipping.png';
import collection from './images/collection.jpg';

export default class PartnerPage extends Basepage<PartnerState, PartnerModel> {
  renderChild(): JSX.Element {
    const MakeList = (props: any): JSX.Element => {
      const ulClass: String = props?.ulClass;
      const liClass: String = props?.liClass;
      const liID: String =
        props?.liID == '' ? liClass : `${liClass}-${props?.liID}`;
      const list: Array<String> = props?.list;

      return (
        <ul className={`${ulClass}`}>
          {list.map((entry: String, index: number) => {
            return (
              <li
                className={`${liClass}`}
                id={`${liID}-${index}`}
                key={`${liID}-${index}`}
              >
                {entry}
              </li>
            );
          })}
        </ul>
      );
    };

    return (
      <div id="partnerPage" key="partnerPage">
        <div id="headerSection" key="headerSection">
          <div id="headermoluna" key="headermoluna">
            {/*
  MARK: Menü
*/}
            <div id="navMain" key="navMain">
              <ul id="link-list" key="link-list">
                {[
                  'Vorteile',
                  'Ablauf',
                  'Beispiele',
                  'Konditionen',
                  'Partner werden',
                ].map((val) => {
                  const valSmall =
                    val != 'Partner werden' ? val.toLowerCase() : 'onboarding';
                  return (
                    <li
                      className="link-entry"
                      id={`link-entry-${valSmall}`}
                      key={`link-entry-${valSmall}`}
                    >
                      <a
                        id={`link-${valSmall}`}
                        key={`link-${valSmall}`}
                        href={`/partner#${valSmall}`}
                      >
                        {val}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        {/*
  MARK: Body
*/}
        <div id="bodySection">
          {/*
  MARK: Head
*/}
          <div id="hero-section">
            <h1 id="hero-title">
              Ergänzen Sie Ihren Shopify-Shop um passende Bücher –{' '}
              <span>vollautomatisch</span>.
            </h1>
            <p id="hero-subtitle">
              Bieten Sie Ihren Kunden die perfekte Zusatzlektüre. Kein Lager,
              keine Fixkosten, kein Programmieraufwand. Erhöhen Sie Ihren
              Warenkorbwert ohne finanzielles Risiko.
            </p>
            <a href="#onboarding" className="btn-primary" id="btn-onboarding">
              Jetzt Partner werden &amp; Onboarding starten
            </a>
          </div>
          {/*
  MARK: Vorteile
*/}
          <div id="vorteile">
            <h2 className="section-title" id="vorteile-title">
              Ihre Vorteile mit Buchbutler
            </h2>
            <div className="img-container">
              {/* <div className="img-div" id="vorteile-img-div">
                <img className="img" id="vorteile-img" src={collection} />
              </div> */}
            </div>
            <div id="features-grid">
              <div className="card" id="fc-warenkorb">
                <div className="title" id="title-warenkorb">
                  Umsatzplus
                </div>
                <h3>Höhere Warenkörbe</h3>
                <p>
                  Passende Fachbücher und Ratgeber sind der ideale Zusatzartikel
                  für Ihr bestehendes Hauptsortiment.
                </p>
                <MakeList
                  ulClass={'step-bullet'}
                  liClass={'step-bullet-list'}
                  liID={'warenkorb'}
                  list={[
                    'Mehrwert für den Kunden',
                    'Höherer Ertrag pro Bestellung',
                  ]}
                />
              </div>
              <div className="card" id="fc-risiko">
                <div className="title" id="title-risiko">
                  Risikofrei
                </div>
                <h3>0 € Risiko</h3>
                <p>
                  Sie zahlen erst, wenn Sie verkaufen. Keine
                  Registrierungsgebühren, keine monatlichen Mindestumsätze oder
                  Abos.
                </p>
                <MakeList
                  ulClass={'step-bullet'}
                  liClass={'step-bullet-list'}
                  liID={'risiko'}
                  list={['Keine Verkäufe, keine Rechnung']}
                />
              </div>
              <div className="card" id="fc-automatisch">
                <div className="title" id="title-automatisch">
                  Scharfe Prozesse
                </div>
                <h3>Vollautomatisiert</h3>
                <p>
                  Produktexporte, Bestände, Preisupdates und die Übermittlung
                  von Trackingnummern erfolgen komplett digital.
                </p>
                <MakeList
                  ulClass={'step-bullet'}
                  liClass={'step-bullet-list'}
                  liID={'automatisch'}
                  list={[
                    'Kein manueller Aufwand',
                    'Mehrmals tägliche Synchronisation',
                  ]}
                />
              </div>
              <div className="card" id="fc-integration">
                <div className="title" id="title-integration">
                  Einfache integration
                </div>
                <h3>No-Code Integration</h3>
                <p>
                  Für die Einrichtung unserer Shopify App benötigen Sie
                  keinerlei Programmierkenntnisse.
                </p>
                <br></br>
                <MakeList
                  ulClass={'step-bullet'}
                  liClass={'step-bullet-list'}
                  liID={'integration'}
                  list={[
                    'In wenigen Minuten startklar',
                    'Nahtlose Shopify-Anbindung',
                  ]}
                />
              </div>
            </div>
          </div>
          {/*
  MARK: Ablauf
*/}
          <div id="ablauf">
            <h2 className="section-title" id="ablauf-title">
              So einfach funktioniert es
            </h2>
            <div className="img-div" id="dropshipping">
              <img className="img" id="dropshipping-img" src={dropshipping} />
            </div>
            <div id="steps-wrapper">
              <div className="box" id="box-export">
                <div className="number" id="number-1">
                  1. Sortimentssteuerung
                </div>
                <div className="title" id="title-export">
                  Selektieren &amp; Exportieren
                </div>
                <p>
                  Wählen Sie über unsere App bequem die Buchtitel aus, die zu
                  Ihrer Zielgruppe passen. Die Produktdaten fließen direkt in
                  Ihren Shop.
                </p>
                <MakeList
                  ulClass={'bullet'}
                  liClass={'bullet-list'}
                  liID={'export'}
                  list={[
                    'Zielgruppengenaue Buchauswahl',
                    'Automatischer Export in Ihren Shop',
                  ]}
                />
              </div>{' '}
              <div className="box" id="box-update">
                <div className="number" id="number-2">
                  2. Synchronisation
                </div>
                <div className="title" id="title-update">
                  Automatische Updates
                </div>
                <p>
                  Preise, Beschreibungen und Verfügbarkeiten werden fortlaufend
                  und automatisch mit unserem Großhandelsbestand synchronisiert.
                </p>
                <MakeList
                  ulClass={'bullet'}
                  liClass={'bullet-list'}
                  liID={'update'}
                  list={['3 täglich Bestandsdaten', '1 täglich ']}
                />
              </div>{' '}
              <div className="box" id="box-dropshipping">
                <div className="number" id="number-3">
                  3. Fulfillment
                </div>
                <div className="title" id="title-dropshipping">
                  DHL Dropshipping
                </div>
                <p>
                  Verkäufe werden automatisch an unser Lager übermittelt. Wir
                  verpacken und versenden direkt an Ihre Kunden inklusive
                  Trackingcode.
                </p>
                <MakeList
                  ulClass={'bullet'}
                  liClass={'bullet-list'}
                  liID={'dropshipping'}
                  list={[
                    'Keine Lagerung nötig',
                    'Automatisches Tracking per DHL',
                  ]}
                />
              </div>
            </div>
          </div>
          {/*
  MARK: Beispiele
*/}
          <div id="beispiele">
            <h2 className="section-title" id="beispiel-title">
              3 Praxisbeispiele: Der perfekte Match
            </h2>
            <div className="img-div" id="beispiel-img-div">
              <img className="img" id="beispiel-img" src={exampleShop} />
            </div>
            <div id="examples-wrapper">
              <div className="card" id="card-hund">
                <span className="tag" id="tag-hund">
                  Hundebedarf &amp; Zubehör
                </span>
                <div className="title" id="title-hund">
                  Hauptprodukt: Hundehalsband &amp; Leine
                </div>
                <p className="desc" id="desc-hund">
                  <strong>Ergänzung:</strong> Erziehungsratgeber, Welpenfibeln
                  und Rasseporträts direkt als Cross-Selling-Artikel im Checkout
                  anbieten.
                </p>
              </div>
              <div className="card" id="card-outdoor">
                <span className="tag" id="tag-outdoor">
                  Grill- &amp; Outdoor-Shop
                </span>
                <div className="title" id="title-outdoor">
                  Hauptprodukt: Smoker &amp; Grillzubehör
                </div>
                <p className="desc" id="desc-outdoor">
                  <strong>Ergänzung:</strong> BBQ-Rezeptbücher und Smoker-Guides
                  als inspirierenden Zusatzkauf bereitstellen.
                </p>
              </div>
              <div className="card" id="card-kleidung">
                <span className="tag" id="tag-kleidung">
                  Baby- &amp; Kinderbekleidung
                </span>
                <div className="title" id="title-kleidung">
                  Hauptprodukt: Erstausstattung
                </div>
                <p className="desc" id="desc-kleidung">
                  <strong>Ergänzung:</strong> Hochwertige Kinder-Vorlesebücher
                  und Eltern-Ratgeber sinnvoll im Sortiment platzieren.
                </p>
              </div>
            </div>
          </div>
          {/*
  MARK: Konditionen
*/}
          <div id="konditionen">
            <h2 className="section-title" id="konditionen-title">
              Transparente Konditionen
            </h2>
            <p className="example-title" id="example-title-konditionen">
              Keine versteckten Kosten. Sie zahlen rein transaktionsbasiert bei
              erfolgreichem Verkauf.
            </p>
            <div id="pricing-grid">
              <div className="item" id="item-preis">
                <div className="val" id="val-preis">
                  0 €
                </div>
                <div className="lbl" id="lbl-preis">
                  Monatliche Grundgebühr
                </div>
              </div>
              <div className="item" id="item-verkauf">
                <div className="val" id="val-verkauf">
                  0,75 €*
                </div>
                <div className="lbl" id="lbl-verkauf">
                  Handling-Gebühr pro Verkauf
                </div>
                <div className="example-desc" id="pricing-lbl-verkauf">
                  *ab 01.01.2027 0,92 €
                </div>
              </div>
              <div className="item" id="item-porto">
                <div className="val" id="val-porto">
                  1:1
                </div>
                <div className="lbl" id="lbl-porto">
                  DHL-Porto (ohne Aufschlag)
                </div>
              </div>
            </div>
          </div>
          {/*
  MARK: Onboarding
*/}
          <div id="onboarding">
            <h2 className="section-title" id="onboarding-title">
              Jetzt freischalten lassen
            </h2>
            <div id="form-container">
              <form
                id="requestForm"
                action="#"
                method="post"
                onSubmit={async (e) => {
                  //MARK: OnSubmit
                  e.preventDefault();

                  try {
                    const formData: FormData = new FormData(e?.target);
                    let formDataObject: { [index: string]: any } = {};

                    for (const pair of formData.entries()) {
                      formDataObject[pair[0]] = pair[1];
                    }

                    let url = injectPhpDebug(
                      this.state.apiBase +
                        '/PartnerFormular.php?body=' +
                        encodeURIComponent(JSON.stringify(formDataObject)),
                    );

                    const fetching = async (urlReq: any) => {
                      const fetchRes = await fetch(urlReq, {
                        method: 'GET',
                        credentials: 'include',
                        headers: {
                          Accept: 'application/json',
                          'Content-Type': 'application/json',
                        },
                      }).then((res) => res.json());

                      if (fetchRes?.body?.error) {
                        alert(fetchRes?.body?.error);
                      } else {
                        alert(fetchRes?.body);
                      }
                    };

                    fetching(url);
                  } catch (error) {
                    console.error({ Error: error });
                  }
                }}
              >
                <div className="group" id="group-name">
                  <label id="label-name" htmlFor="name">
                    Name / Ansprechpartner
                  </label>
                  <input
                    id="input-name"
                    type="text"
                    name="name"
                    required
                    placeholder="Max Mustermann"
                  />
                </div>
                <div className="group" id="group-email">
                  <label id="label-email" htmlFor="email">
                    E-Mail Adresse
                  </label>
                  <input
                    id="group-input-email"
                    type="email"
                    name="email"
                    required
                    placeholder="max@ihr-shop.de"
                  />
                </div>
                <div className="group" id="group-shop">
                  <label id="label-shop" htmlFor="shop">
                    Shopify Store URL
                  </label>
                  <input
                    id="input-shop"
                    type="text"
                    name="shop"
                    required
                    placeholder="meine-domain.myshopify.com"
                  />
                </div>
                <div className="group" id="group-message">
                  <label id="label-message" htmlFor="message">
                    Welche Buchkategorien suchen Sie? (Optional)
                  </label>
                  <textarea
                    id="textarea"
                    name="message"
                    placeholder="z. B. Hundebücher, Kochbücher, Ratgeber..."
                  ></textarea>
                </div>
                <button type="submit" className="btn-primary" id="btn-submit">
                  Jetzt unverbindlich anfragen
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
  initState(base: BasePageState): PartnerState {
    let newState: PartnerState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Partner';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Partner</span>;
  }
  getType(): string {
    return 'PartnerPage';
  }
}
